module.exports = __webpack_public_path__ + "img/3.6c2539cc.webp";